import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";

import useCompetition from "../../hooks/useCompetition";
import ScorecardScreen from "../../modules/entry/components/screens/ScorecardScreen/ScorecardScreen";
import RouteSelector from "./RouteSelectorScreen/RouteSelectorScreen";

export default function MainScreen() {
  const { competitionUUID } = useParams();
  const { competition } = useCompetition(competitionUUID);

  if (!competition) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spinner animation="border" />
      </div>
    );
  }
  if (competition.canJudge) {
    return <RouteSelector />;
  } else {
    return <ScorecardScreen />;
  }
}
